import React from "react";
import { Link } from "react-router-dom";
import styles from "../InverluxApps.module.css";

const TabGroupSharePrivacy = () => (
  <section className={styles.policySection}>
    <div className={styles.policyWidth}>
      <p className={styles.eyebrow}>Tab Group Share</p>
      <h1>Privacy Policy</h1>
      <p className={styles.policyDate}>
        Effective date: October 14, 2026. Publisher: Inverlux LLC.
      </p>

      <article className={`${styles.policyContent} ${styles.tabGroupSharePolicy}`}>
        <p>
          Tab Group Share operates locally in Chrome. It has no server,
          accounts, analytics, advertising, tracking, or external APIs. It does
          not access Chrome's browsing-history database or monitor browsing.
          Tab titles, URLs, group metadata, and manually pasted import text are
          processed locally for the visible export/import features. The
          extension does not transmit this data to the developer or any
          external service.
        </p>
        <p>
          When you explicitly export a tab group, the extension reads that
          group's name, color, collapsed state, and ordered tab titles and URLs,
          and writes your selected representation to the system clipboard.
          It does not read the clipboard. You control where you paste or share
          that text. Local file paths and titles are redacted from exports.
        </p>
        <p>
          When you paste content into the import page, it is parsed locally.
          No tabs are opened until you preview and confirm. Valid HTTP/HTTPS
          URLs are opened as normal browser tabs. Those websites then receive
          the requests and may handle data according to their own policies,
          just as when you visit them yourself.
        </p>
        <p>
          Exported lists and import text are not persistently stored by the
          extension. Export fallback text is held briefly in service-worker
          memory until its page retrieves it; opened extension pages retain
          their displayed text for their lifetime. Offscreen clipboard text is
          cleared after each copy attempt. The clipboard itself remains
          managed by your operating system and any clipboard tools you use.
        </p>
        <p>
          Permissions are limited to reading tab metadata, managing tab groups,
          creating context-menu commands, and writing the clipboard through
          an offscreen document. The extension requests no clipboard-reading
          or host permissions and injects no content scripts.
        </p>
        <p>
          Closing an extension page discards its in-page text. Uninstalling
          removes the extension; it does not close tabs you imported or clear
          your operating system's clipboard.
        </p>

        <h2>Limited Use</h2>
        <p>
          Tab Group Share uses tab titles, URLs, group metadata, and pasted
          import text only to provide its visible tab-group export and import
          features. Its use of information received from Chrome APIs complies
          with the Chrome Web Store User Data Policy, including the Limited
          Use requirements. Inverlux does not receive this locally processed
          data, use it for advertising or profiling, sell it, or allow people
          to review it through the extension.
        </p>

        <h2>Contact</h2>
        <p>
          For privacy questions, contact Inverlux LLC at{" "}
          <a href="mailto:support@inverlux.com">support@inverlux.com</a>. If the
          extension's data practices change, this policy and the store
          disclosures will be updated before those changes take effect.
        </p>
      </article>

      <div className={styles.policyLinks}>
        <Link to="/tab-group-share">Back to Tab Group Share</Link>
        <Link to="/support">Contact support</Link>
      </div>
    </div>
  </section>
);

export default TabGroupSharePrivacy;
